<div class="wbi-nm">
  <div class="wbi-nm-head">
    <span class="wbi-nm-title">{{ '$notifications.title' | translateAsync }}</span>
    @if (unreadCount()) {
      <span class="wbi-nm-count">{{ unreadCount() }}</span>
    }
  </div>

  <mat-divider></mat-divider>

  @if (!compact().length) {
    <div class="wbi-nm-empty">
      <mat-icon>notifications_none</mat-icon>
      <span>{{ '$notifications.empty-unread' | translateAsync }}</span>
    </div>
  } @else {
    <ul class="wbi-nm-list">
      @for (notification of compact(); track notification.id) {
        <li class="wbi-nm-item" [class]="'sev-' + notification.severity.toLowerCase()">
          <div class="wbi-nm-item-text">
            <span class="wbi-nm-item-head">
              <span class="wbi-nm-item-title">{{ notification.title }}</span>
              <span class="wbi-nm-item-date">{{ notification.created_at | date: 'short' }}</span>
            </span>
            @if (notification.body) {
              <span class="wbi-nm-item-body">{{ notification.body }}</span>
            }
          </div>
          <button
            mat-icon-button
            type="button"
            [matTooltip]="'$notifications.mark-read' | translateAsync"
            (click)="markRead(notification, $event)"
          >
            <mat-icon>done</mat-icon>
          </button>
        </li>
      }
    </ul>
  }

  <mat-divider></mat-divider>

  <div class="wbi-nm-foot">
    <button
      mat-button
      type="button"
      class="wbi-nm-all"
      [disabled]="!unreadCount()"
      (click)="markAllRead($event)"
    >
      <mat-icon>done_all</mat-icon>
      <span>{{ '$notifications.mark-all-read' | translateAsync }}</span>
    </button>

    <button mat-button type="button" class="wbi-nm-more" (click)="seeMore()">
      <span>{{ '$notifications.see-more' | translateAsync }}</span>
      @if (hiddenCount()) {
        <span class="wbi-nm-more-count">+{{ hiddenCount() }}</span>
      }
    </button>
  </div>
</div>
